import { render } from "./PaymentTermsContentPageList.vue?vue&type=template&id=d4ab5024&scoped=true&ts=true"
import script from "./PaymentTermsContentPageList.vue?vue&type=script&lang=ts"
export * from "./PaymentTermsContentPageList.vue?vue&type=script&lang=ts"

import "./PaymentTermsContentPageList.vue?vue&type=style&index=0&id=d4ab5024&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ab5024"]])

export default __exports__